import React, { forwardRef } from 'react';
import {
    BaseSolidButtonProps,
    BaseSolidButtonContent,
    solidButtonStyles,
} from '../BaseSolidButton';
import styled from 'styled-components';

interface AnchorButtonProps
    extends React.AnchorHTMLAttributes<HTMLAnchorElement>,
        Omit<BaseSolidButtonProps, 'processing'> {}

type Ref = React.Ref<HTMLAnchorElement>;

export const AnchorButton = forwardRef(function AnchorButton(props: AnchorButtonProps, ref: Ref) {
    const {
        className,
        children,
        icon,
        size,
        selected: ignored,
        onClick,
        disabled,
        ...rest
    } = props;

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>): void | false => {
        if (disabled) {
            event.preventDefault();
            return false;
        }
        if (onClick) onClick(event);
    };

    return (
        <a {...rest} ref={ref} className={className} onClick={handleClick} aria-disabled={disabled}>
            <BaseSolidButtonContent icon={icon} label={children} size={size} />
        </a>
    );
});

export const SolidAnchorButton = styled(AnchorButton)<AnchorButtonProps>(solidButtonStyles);
